import axios from "axios";
import AuthenticationFailureHandler from "../utils/AuthenticationFailureHandler";
import { BASE_URL } from "../utils/EmpUtil";
import { is401 } from "../errors/ErrorConstants";

class HelpAndSupportClient {
  static baseUrl = BASE_URL;

  static getFAQs() {
    const url = `${this.baseUrl}/faq`;

    return axios
      .get(url)
      .then((response) => response.data)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }
}

export default HelpAndSupportClient;
